import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedUiComponentsCoreModule } from '@domgen/dgx-fe-components-core';
import { DgxComponentsButtonModule } from '@domgen/dgx-fe-components/button';
import { SharedUiDynamicFormBuilderModule } from '@domgen/dgx-fe-dynamic-form-builder';
import { AdditionalDeviceBannerComponent } from './additional-device-banner/additional-device-banner.component';
import { EmptyBasketComponent } from './empty-basket/empty-basket.component';
import { SkyUiOrderSummaryItemComponent } from './order-summary-item/order-summary-item.component';
import { SkyUiOrderSummaryComponent } from './order-summary/order-summary.component';
import { ReadAndAcceptPolicyComponent } from './read-and-accept-policy/read-and-accept-policy.component';

export const components = [
  ReadAndAcceptPolicyComponent,
  SkyUiOrderSummaryComponent,
  SkyUiOrderSummaryItemComponent,
  AdditionalDeviceBannerComponent,
  EmptyBasketComponent,
];

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DgxComponentsButtonModule,
    SharedUiComponentsCoreModule,
    SharedUiDynamicFormBuilderModule,
  ],
  declarations: [...components],
  exports: [...components],
})
export class SkyUiComponentsModule {}
